import React, { useEffect } from 'react';
import { Paper, Box } from '@mui/material';
import CustomSignIn from 'components/authentication/CustomSignIn';
import { LOGOS } from 'shared/constants';
import AnalyticsService from 'services/analytics';

const Login: React.FC = () => {
  useEffect(() => {
    AnalyticsService.logPageview(
      `/virtual/login${window.location.pathname}${window.location.search}`,
    );
  }, []);

  return (
    <Box
      component="main"
      className="page-grid__full"
      sx={(t) => ({
        [t.breakpoints.up('md')]: {
          backgroundImage: 'url(/img/backgrounds/main_bg--xl.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        },
      })}
    >
      <Paper
        sx={(t) => ({
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
          maxWidth: '100%',
          width: '100%',
          [t.breakpoints.up('md')]: {
            justifyContent: 'flex-end',
            width: '29rem',
          },
          [t.breakpoints.up('lg')]: {
            width: '33rem',
          },
          [t.breakpoints.up('xl')]: {
            width: '25%',
          },
        })}
        elevation={5}
        square
      >
        <Box
          sx={(t) => ({
            rowGap: '2rem',
            margin: '2rem',
            maxHeight: '100%',
            maxWidth: '25rem',
            width: '100%',
            [t.breakpoints.up('lg')]: {
              margin: '4rem',
            },
          })}
        >
          <figure>
            <Box
              component="img"
              src={LOGOS.voyagerWide}
              alt=""
              sx={{ display: 'block', margin: '0 auto 1.5rem', maxWidth: '15rem' }}
            />
          </figure>
          <Box>
            <CustomSignIn />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
